module.exports = require("@axisvue/tailwind-config/tailwind.config");
